import { ElementRef, HostListener, Directive } from '@angular/core';

@Directive({ standalone: false, selector: 'textarea[autosize]', exportAs: 'autosizedirective' })
export class Autosize {
	@HostListener('input', ['$event.target'])
	onInput(textArea: HTMLTextAreaElement): void {
		this.adjust();
	}

	constructor(public element: ElementRef) {}

	ngOnInit(): void {
		this.adjust();
	}

	adjust(): void {
		let el = this.element.nativeElement;

		let orgHeight = el.style.height;

		el.style.overflow = 'hidden';
		el.style.height = '';

		let borderCorrection = el.offsetHeight - el.clientHeight;
		let newHeight = el.scrollHeight + borderCorrection;

		if (newHeight === 0) newHeight = orgHeight;

		el.style.height = newHeight + 'px';
	}
}
